import React, { useState } from "react";
import { Input, Select, DatePicker, TreeSelect, Tooltip, message } from "antd";
import { ProColumns } from "@ant-design/pro-table";
import { Link, useHistory } from "react-router-dom";
import { useDictEnumHooks, useHasAuthCode } from "@hooks/index";
import { useSelector } from "react-redux";
import { StateType } from "@store/index";
import { customerSeePhoneNumber } from '@api/index'
import { strIsEmpty } from "@utils/util";

// ts--types
export type TableListItem = {
    key: number;
    isSyn: number;
    id: number;
    customerName: string;
    belongerName: string;
    type: number;
    applicantName: string;
    fixedTelephoneNumber: string;
};
const RenderPhoneNumber = ({ record }: any) => {
    const { id, mobilePhoneNumber, repeatPhoneNumber, type, whetherContactOwner } = record || {}
    const [text, setText] = useState(mobilePhoneNumber)
    const onOwnClick = async () => {
        if (whetherContactOwner) {
            const { data } = await customerSeePhoneNumber({ id, type }) as any
            setText(data)
        } else {
            message.error('您无权查看该信息')
        }
    }
    return (<div>
        <Tooltip placement="top" title={`该号码在系统中已重复${repeatPhoneNumber}个`}>{text}</Tooltip>
        {/* { (text||'').length ? <Icon type="icon-icon_yulan" style={{cursor: 'pointer'}} onClick={onOwnClick} /> : null} */}
    </div>)
}

export type OperateActionType = '审批' | '查看审批'

export const columnsFn: (operate?: Function, type?: String) => ProColumns<TableListItem>[] = (operate, type) => {
    const { deptWithUserTreeData } = useSelector((state: StateType) => state)
    const [, , request] = useDictEnumHooks({ dictId: 13 }, false)
    const [, hasAuthCode] = useHasAuthCode()
    let column = [
        {
            title: '客户名称',
            dataIndex: 'customerName',
            key: 'customerName',
            order: 100,
        },
        {
            title: '归属人',
            dataIndex: 'belongerName',
            key: 'belongerName',
            hideInSearch: true,
        },
        {
            title: '客户所在位置',
            dataIndex: 'type',
            key: 'type',
            hideInSearch: true,
            render: (text: any, record: any) => text === 1 ? '客户' : '线索池',
        },
        {
            title: '申请人',
            dataIndex: 'applicantName',
            key: 'applicantName',
            hideInSearch: true,
        },
        {
            title: '业务线',
            dataIndex: 'fixedTelephoneNumber',
            key: 'fixedTelephoneNumber',
            hideInSearch: true,
        },
        {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            readOnly: true,
            hideInSearch: true,
            width: 80,
            render: (text: string, record: object) => [
                strIsEmpty(record.res) ? <a key="approve" onClick={() => operate && operate('审批', record)}>审批</a> : null
            ]
        }
    ]
    if (type === "2") {
        column = [
            {
                title: '客户名称',
                dataIndex: 'customerName',
                key: 'customerName',
                order: 100,
            },
            // {
            //     title: '归属人',
            //     dataIndex: 'belongerName',
            //     key: 'belongerName',
            //     hideInSearch: true,
            // },
            {
                title: '客户所在位置',
                dataIndex: 'type',
                key: 'type',
                hideInSearch: true,
                render: (text: any, record: any) => text === 1 ? '客户' : '线索池',
            },
            {
                title: '报备状态',
                dataIndex: 'isPass',
                key: 'isPass',
                hideInSearch: true,
                render: (text: any) => strIsEmpty(text) ? '审批中' : ['拒绝', "通过"][text],
            },
            {
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                readOnly: true,
                width: 100,
                hideInSearch: true,
                render: (text: string, record: object) => [
                    <a key="approveView" onClick={() => operate && operate('查看审批', record)}>查看审批</a>
                ]
            }
        ]
    }
    return column
}
